<template>
  <div :style="`${isPromotion ? 'padding:20px' : ''}`" class="content">
    <Search :hiddenExport="true" :loading="searchForm.loading"
            :searchForm="searchForm" :searchList="searchList">
      <button>新增</button>
    </Search>

    <!-- 表格 -->
    <dd-coupon-synchronization-table :loading="searchForm.loading"
                                     :order-status="searchForm.orderStatus"
                                     :table-list="tableList.list"
                                     @refreshData="getList"></dd-coupon-synchronization-table>
    <!-- 分页 -->
    <el-pagination
      v-if="tableList.total > 0"
      :current-page="searchForm.pageNo"
      :page-size="tableList.pageSize"
      :page-sizes="[10, 20, 30, 40]"
      :total="tableList.total"
      class="pagination"
      layout="total, sizes, prev, pager, next, jumper"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange">
    </el-pagination>
  </div>
</template>

<script>
import Search from "@/components/Search";

import DdCouponSynchronizationTable from "./components/ddCinemaManagementTable.vue";
import mini from "@/api/mini";

const MiniModel = new mini()

export default {
  name: "ddCinemaManagement",
  components: {
    DdCouponSynchronizationTable,
    Search,
  },
  data() {
    return {
      activeName: '0',
      searchForm: {
        cinemaName: '',
        name: '',
        loading: true,
        pageSize: 10,
        pageNo: 1,
      },
      searchList: [
        {
          id: 'name',
          text: '分类名称',
          placeholder: '请输入分类名称',
          type: 'input'
        },
        {
          id: 'cinemaName',
          text: '影院名称',
          placeholder: '请输入影院名称',
          type: 'input'
        },
      ],
      tableList: {
        list: [],
        total: 0,
        pageSize: 10
      },
      currentPage: 1,
      isPromotion: false,
    }
  },

  mounted() {
    this.getList()
    // 获取hash值
    this.isPromotion = window.location.hash.includes('promotion')
  },
  methods: {
    getList() {
      this.searchForm.loading = true
      MiniModel.dyCinemaSearch({
        ...this.searchForm,
      }).then(res => {
        this.searchForm.loading = false
        if (res.data.code === 200) {
          this.tableList = res.data.data
        } else {
          this.$message.error(res.data.info)
        }
      }).finally(() => {
      })
    },
    handleClick(e) {
      // 如果是已处理 隐藏 淘宝订单号搜索条件 isHide 为true
      if (e.name === "1") {
        //  显示
        this.searchList.forEach(item => {
          if (item.id === 'tbOrderId') {
            item.isHide = false
          }
          if (item.id === 'orderId') {
            item.isHide = false
          }
          if (item.id === 'status') {
            item.isHide = false
          }
          if (item.id === 'operateTime') {
            item.isHide = false
          }
        })

      } else {
        // 隐藏
        this.searchList.forEach(item => {
          if (item.id === 'tbOrderId') {
            item.isHide = true
          }
          if (item.id === 'orderId') {
            item.isHide = true
          }
          if (item.id === 'status') {
            item.isHide = true
          }
          if (item.id === 'operateTime') {
            item.isHide = true
          }
        })
      }

      // 重置搜索条件
      this.searchForm = {
        tabIndex: e.name === "0" ? 0 : 1,
        pageSize: 10,
        pageNo: 1,
        serviceNickName: '',
        shopName: '',
        orderId: '',
        inquiryId: '',
        status: '',
        tbOrderId: '',
        time: [],
        operateTime: [],
        startCreateTime: '',
        endCreateTime: '',
        operateBeginTime: '',
        operateEndTime: '',
        loading: true
      }
      this.searchList.list = []
      this.getList();
    },
    handleSizeChange(val) {
      this.searchForm.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.searchForm.pageNo = val;
      this.getList();
    },
  }
}
</script>
<style>
.el-icon-circle-close {
  color: red;
}

</style>
<style lang="less" scoped>

.content {
  background: #FFFFFF;
  border-radius: 8px;

  .title {
    font-size: 20px;
    color: #222222;
    text-align: left;
    font-weight: bold;
  }
}

.pagination {
  margin-top: 20px;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/miniProgram/ddCouponExchange/ddCinemaManagement/index.vue